/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q7Inputs */

const en_to_xml_faq_q7 = /** @type {(inputs: To_Xml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is there no SOAP envelope or namespace?`)
};

const ko_to_xml_faq_q7 = /** @type {(inputs: To_Xml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 SOAP 엔벨로프나 네임스페이스가 없나요?`)
};

const ja_to_xml_faq_q7 = /** @type {(inputs: To_Xml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ SOAP エンベロープや名前空間がないのですか`)
};

/**
* | output |
* | --- |
* | "Why is there no SOAP envelope or namespace?" |
*
* @param {To_Xml_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q7 = /** @type {((inputs?: To_Xml_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q7(inputs)
	if (locale === "ko") return ko_to_xml_faq_q7(inputs)
	return ja_to_xml_faq_q7(inputs)
});